import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../models/response.model';
import { ContactUs } from '../models/contact.us.model';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {

  _profileEndpoint = `${environment.apiBaseUrl}/user/v1/customer/`;

  constructor(private _http: HttpClient) { }

  contactUs(params: ContactUs) {
    return this._http
      .post<ApiResponse<any>>(`${environment.apiBaseUrl}/user/v1/support/contact-us`, params)
      .pipe(map((res) => res));
  }
}
